import { useState } from "react";
import style from "./ProfileReviewCards.module.css";
import TablePagination from "@/ui/tablePagination/TablePagination";
import UserReviewCard from "@/features/reviews/components/userReviewCard/UserReviewCard";
import { useGetUserReviews } from "../../hooks/useGetUserReviews";
import { useGetUserByUsername } from "../../hooks/useGetUserByUsername";

function ProfileReviewCards({ username }) {
	const { reviews, isPending } = useGetUserReviews(username);
	const { user, isPending: userIsPending } = useGetUserByUsername(username);

	const [pagination, setPagination] = useState({
		pageIndex: 0,
		pageSize: 2,
	});

	const startIndex = pagination.pageIndex * pagination.pageSize;
	const endIndex = startIndex + pagination.pageSize;
	const paginatedReviews = reviews.slice(startIndex, endIndex);

	const table = {
		getState: () => ({ pagination }),
		getRowCount: () => reviews.length,
		getCanPreviousPage: () => pagination.pageIndex > 0,
		getCanNextPage: () => endIndex < reviews.length,
		previousPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex - 1,
			})),
		nextPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex + 1,
			})),
	};

	if (isPending && userIsPending) return <></>;

	return (
		<>
			{!reviews ||
				(reviews.length != 0 && (
					<div className={style.reviewsHolder}>
						<div className={style.header}>
							<span className={style.line}></span>
							<span className={style.title}>
								Recenzije kurseva ({reviews.length})
							</span>
							<span className={style.line}></span>
						</div>
						{paginatedReviews.map((review) => (
							<UserReviewCard
								key={review.timestamp}
								user={user}
								review={review}
							/>
						))}
						{reviews.length > pagination.pageSize && (
							<TablePagination table={table} />
						)}
					</div>
				))}
		</>
	);
}

export default ProfileReviewCards;
